export const robotIdentityKeys = {
  allRobots: ['identity'] as const,
  identities: (robotId: string) =>
    [...robotIdentityKeys.allRobots, robotId] as const,
  identity: (robotId: string, identity_id: string) =>
    [...robotIdentityKeys.identities(robotId), identity_id] as const,
};
